<template>
  <div class="contract-dispute">
    <div class="contract-dispute__header">
      <h2 class="contract-dispute__header-title">{{i18n.cont_dispute_information()}}</h2>
    </div>
    <div class="contract-dispute__wrapper">
      <div class="contract-dispute__details-row">
        <div class="contract-dispute__document-name">
          <h3>{{i18n.lbl_documents()}}</h3>
        </div>
        <div class="contract-dispute__document-submitter">
          <h3>{{i18n.lbl_submitted_by()}}</h3>
        </div>
        <div class="contract-dispute__document-type">
          <h3>{{i18n.lbl_type()}}</h3>
        </div>
        <div class="contract-dispute__documents-view-btn">
          <!-- open file button -->
        </div>
      </div>
      <div class="contract-dispute__details-row">
        <div class="contract-dispute__document-name">
          <i class="document-icon material-icons">note</i>
          <p>{{disputeFile.name}}</p>
        </div>
        <div class="contract-dispute__document-submitter">
          <email-getter :id="dispute.author" />
        </div>
        <div class="contract-dispute__document-type">
          <p>{{disputeFile.type}}</p>
        </div>
        <div class="contract-dispute__documents-view-btn">
          <a :href='getUrl' target='_blank'>{{i18n.lbl_open()}}</a>
        </div>
      </div>
      <detail-row :prop="i18n.lbl_note()"
                  :value="disputeDetails.note"
                  :alignLeft="true"
                  :colWidth="[15, 85]"
                  keyTextColor="$col-text-bright"
                  valueTextColor="$col-text-bright"/>
      <template v-for="(item, i) in notes">
        <div class="contract-dispute__escrow-appeal-row" :key="i">
          <h3 v-if="item.author !== escrow">{{i18n.cont_appeal_escrow_by()}}
            <email-getter :id="item.author" />
          </h3>
          <h3 v-else>
            {{i18n.cont_escrow_resolution()}}
          </h3>
          <detail-row :prop="i18n.lbl_note()"
                      :value="item.details.note"
                      :alignLeft="true"
                      class="contract-dispute__note-row"
                      :colWidth="[15, 85]"/>
        </div>
      </template>
    </div>
    <div class="contract-dispute__action-wrapper">
      <md-button class="md-primary"
            @click="isAppealingEscrow = true"
            :disabled="isPending || hasAppealed">{{ i18n.cont_appeal_to_escrow() }}</md-button>
    </div>
    <modal v-if="isAppealingEscrow"
            @close-request="isAppealingEscrow = false"
            maxWidth="600px">
      <appeal-escrow :contractId="contractId"
                      @load-contract="loadContract"/>
    </modal>
  </div>
</template>

<script>
import get from 'lodash/get'
import { i18n } from '@js/i18n'
import {
  documentTypes,
  ACCOUNT_TYPES,
  REQUEST_STATES_STR,
  CONTRACT_STATES
} from '@const'

import config from '@conf'
import { mapGetters } from 'vuex'
import { vuexTypes } from '@vuex/types'

import DetailRow from '@vue/app/common/Detail.Row'
import EmailGetter from '@vue/app/common/EmailGetter'
import Modal from '@vue/app/common/Modal'
import AppealEscrow from './modals/Contracts.AppealEscrow'
import FormMixin from '@com/mixins/form.mixin'

export default {
  components: {
    DetailRow,
    AppealEscrow,
    Modal,
    EmailGetter },
  props: [
    'contractId',
    'dispute',
    'notes',
    'escrow'
  ],
  mixins: [FormMixin],
  data: _ => ({
    isAppealingEscrow: false,
    i18n,
    documentTypes,
    ACCOUNT_TYPES,
    REQUEST_STATES_STR,
    CONTRACT_STATES
  }),

  computed: {
    ...mapGetters([
      vuexTypes.accountId
    ]),
    disputeDetails () {
      return this.dispute.details
    },
    disputeFile () {
      const fileName = get(this.disputeDetails, 'dispute_file.name', '')
      const [name, type] = fileName.split(/\.(?=[^.]+$)/)
      return {
        name: name,
        type: type
      }
    },
    getUrl () {
      const key = get(this.disputeDetails, 'dispute_file.key')
      if (!key) return ''
      return `${config.FILE_STORAGE}/${key}`
    },
    hasAppealed () {
      if (!this.notes) return false
      return !!this.notes.find(item => item.author === this.accountId)
    }
  },
  methods: {
    loadContract () {
      this.isAppealingEscrow = false
      this.$emit('load-contract')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .contract-dispute {
    margin-top: 1.5rem;
    background-color: $col-background-content;
    // md-card styles
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
  }

  .contract-dispute__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .contract-dispute__header-title {
    padding: 1.5rem;
  }

  .contract-dispute__wrapper {
    display: flex;
    flex-direction: column;
    background-color: $col-background;
    color: $col-text-bright;
  }

  .contract-dispute__row {
    border-bottom: 1px solid $col-background;
  }

  .contract-dispute__details-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .contract-dispute__document-name {
    width: 65%;
    display: flex;
    align-items: center;
  }

  .contract-dispute__document-submitter {
    width: 20%;
    text-align: center;
  }

  .contract-dispute__document-type {
    width: 10%;
    text-align: center;
  }

  .contract-dispute__documents-view-btn {
    text-align: center;
    width: 5%;
  }

  .document-icon {
    /*font-size: $material-icon-big-but-not-so-big;*/
    margin-right: .5rem;
  }

  .contract-dispute__wrapper {
    padding: 0 1.5rem 1rem;
    /*background-color: $col-content-block;*/
  }

  .contract-dispute__action-wrapper { text-align: right; }
  .contract-dispute__escrow-appeal-row,
  .contract-dispute__note-row { margin-top: 1rem; }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/Contracts.Dispute.vue